import { AxiosInstance } from "axios"
import { MeetingDetailsOrder } from "./meetingTypes"

export enum ServiceCenterMeetingQuery {
    SERVICE_CENTER_MEETING_DETAILS = "service-center-meeting-details",
}

export type OrderDetailsResponse = Readonly<{
    orders: MeetingDetailsOrder[]
}>

export async function fetchOrderDetails(
    {
        orderId,
    }: {
        orderId: number
    },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<OrderDetailsResponse> {
    const response = await axios.get(`/meetingService/orders/${orderId}`, { signal })

    return response.data
}
